/* ================================================================
   ALPHA MOTION v2 — Alpha Elements 18K
   Archivo: assets/alpha-motion.js   (vanilla, sin dependencias)

   Registro tomado de mediciones en vivo sobre cartier.com,
   tiffany.com y vancleefarpels.com (ninguna usa libreria de
   animacion): entradas de 0,5 s con curva de cola larga, titulares
   que suben desde detras de una mascara, imagenes que se descubren
   con cortina, y filetes dorados que se dibujan entre secciones.

   Reparto de responsabilidades para que nada se pise:
     · reveal    -> escribe opacity/transform en CONTENEDORES
     · mascara   -> escribe transform en un <span> interno
     · barrido   -> escribe clip-path en el contenedor de la imagen
     · parallax  -> escribe transform en los <img>
   Nunca dos cosas sobre la misma propiedad del mismo nodo.

   NO toca el header: el tema ya trae sticky nativo.
   ================================================================ */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function onLoad(fn) {
    if (document.readyState === 'complete') fn();
    else window.addEventListener('load', fn);
  }
  function home() {
    return document.querySelector('main[data-template^="index"]');
  }

  /* ---------- titular envuelto en mascara ---------- */
  function maskHeading(h) {
    if (!h || h.querySelector('.am-mask')) return false;
    var txt = h.textContent;
    if (!txt || !txt.trim()) return false;
    // Solo contenido en linea: si el titular trae bloques dentro,
    // envolverlo romperia el layout.
    if (h.querySelector('div,section,ul,ol,table,p')) return false;
    var inner = h.innerHTML;
    h.innerHTML = '<span class="am-mask"><span class="am-mask__i">' + inner + '</span></span>';
    return true;
  }

  /* ---------- 1. REVEAL + ORQUESTACION POR SECCION ---------- */
  function initReveal() {
    var main = home();
    if (!main || !hasIO || reduce) return;

    root.classList.add('alpha-js');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    );

    var SEL = 'h1,h2,h3,p,img,video,.product-card,a[class*="button"],button[class*="button"]';
    var vh = window.innerHeight || 800;
    var observados = [];
    var inmediatos = [];

    var secciones = main.querySelectorAll(':scope > .shopify-section');

    Array.prototype.forEach.call(secciones, function (sec, idx) {
      if (sec.querySelector('[data-pf-type]')) return;              // PageFly tiene el suyo
      var esVortice = sec.classList.contains('alpha-vortex-section');

      /* --- filete dorado entre secciones ---
         Ritmo tipo Cartier. No se pone antes del hero, del slideshow
         ni del vortice, que son bloques a sangre completa. */
      if (idx >= 3 && !esVortice && sec.parentNode) {
        var rule = document.createElement('div');
        rule.className = 'am-rule';
        rule.setAttribute('aria-hidden', 'true');
        sec.parentNode.insertBefore(rule, sec);
        io.observe(rule);
        observados.push(rule);
      }

      if (esVortice) return; // el vortice trae su propia entrada

      // Las mascaras se aplican ANTES de medir posiciones.
      var conMascara = [];
      Array.prototype.forEach.call(sec.querySelectorAll('h1,h2,h3'), function (h) {
        if (maskHeading(h)) conMascara.push(h);
      });

      var chosen = [];

      Array.prototype.forEach.call(sec.querySelectorAll(SEL), function (el) {
        if (chosen.length >= 6) return;

        // Una imagen se anima por su CONTENEDOR: el <img> queda libre
        // para el parallax, que tambien escribe transform.
        var esMedia = el.tagName === 'IMG' || el.tagName === 'VIDEO';
        var target = el;
        if (esMedia) {
          target = el.parentElement;
          if (!target || target === sec) return;
        }

        if (target.hasAttribute('data-alpha-reveal')) return;
        if (target.closest('[data-pf-type]')) return;

        for (var i = 0; i < chosen.length; i++) {
          if (chosen[i] === target || chosen[i].contains(target)) return;
        }
        if (!target.getClientRects().length) return;

        target.__amMedia = esMedia;
        target.__amMask = conMascara.indexOf(target) !== -1;
        chosen.push(target);
      });

      chosen.forEach(function (el, i) {
        el.setAttribute('data-alpha-reveal', '');
        el.setAttribute('data-alpha-delay', String(Math.min(i, 5)));
        if (el.__amMedia) el.setAttribute('data-am-kind', 'media');
        // Si el propio titular lleva mascara, se le quita el
        // desplazamiento base: si no, se moveria dos veces.
        if (el.__amMask) el.classList.add('am-has-mask');

        if (el.getBoundingClientRect().top < vh * 0.92) inmediatos.push(el);
        else { io.observe(el); observados.push(el); }
      });
    });

    // Lo que ya esta en pantalla entra en el primer frame. Se hace en
    // un rAF y no en la misma vuelta para que el navegador registre el
    // estado inicial y la transicion se vea; si no, aparece de golpe.
    function revelarInmediatos() {
      inmediatos.forEach(function (el) { el.classList.add('is-in'); });
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(revelarInmediatos);
    });
    // Respaldo por temporizador: en una pestana abierta en segundo
    // plano el navegador pausa requestAnimationFrame, y sin esto el
    // hero se quedaria invisible hasta que el usuario la enfocara.
    setTimeout(revelarInmediatos, 400);
    // Y ademas entran en la ronda del vigilante de mas abajo.
    observados = observados.concat(inmediatos);

    /* SEGURO CONTRA CONTENIDO INVISIBLE.
       Rescata SOLO lo que ya esta dentro del viewport, es decir lo
       que el observer deberia haber revelado y no revelo. Lo de mas
       abajo conserva su animacion para quien lee despacio. */
    if (observados.length) {
      var intentos = 0;
      var vigilante = setInterval(function () {
        intentos++;
        var alto = window.innerHeight || 800;
        var pendientes = 0;
        for (var i = 0; i < observados.length; i++) {
          var el = observados[i];
          if (el.classList.contains('is-in')) continue;
          pendientes++;
          var r = el.getBoundingClientRect();
          if (r.top < alto && r.bottom > 0) el.classList.add('is-in');
        }
        if (!pendientes || intentos >= 8) clearInterval(vigilante);
      }, 2500);
    }
  }

  /* ---------- 2. DERIVA LENTA DEL HERO ---------- */
  function initHeroDrift() {
    if (reduce) return;
    var main = home();
    if (!main) return;
    var img = main.querySelector('.hero img, .hero__image');
    if (img) img.classList.add('am-drift');
  }

  /* ---------- 3. ANTETITULO DEL VORTICE ---------- */
  function initEyebrow() {
    var eb = document.querySelector('.av-eyebrow');
    if (!eb) return;
    eb.classList.add('am-eyebrow');
    if (reduce || !hasIO) { eb.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.3 });
    io.observe(eb);
    setTimeout(function () { eb.classList.add('is-in'); }, 9000); // seguro
  }

  /* ---------- 4. PARALLAX SUTIL ---------- */
  function initParallax() {
    var main = home();
    if (!main || !hasIO || reduce) return;

    var MAX = 10;
    var items = [];

    Array.prototype.forEach.call(main.querySelectorAll('.shopify-section img'), function (img) {
      var sec = img.closest('.shopify-section');
      if (!sec || sec.classList.contains('alpha-vortex-section')) return;
      if (img.closest('.hero')) return;
      if (img.closest('.product-card')) return;

      var r = img.getBoundingClientRect();
      if (r.height < 320) return;

      var parent = img.parentElement;
      if (!parent) return;
      if (getComputedStyle(parent).overflow === 'visible') return;

      img.setAttribute('data-am-parallax', '');
      items.push({ el: img, top: 0, h: 0 });
    });

    if (!items.length) return;

    function measure() {
      var sy = window.scrollY || 0;
      items.forEach(function (it) {
        var r = it.el.getBoundingClientRect();
        it.top = r.top + sy;
        it.h = r.height;
      });
    }

    var active = [];
    var raf = null;

    function frame() {
      var sy = window.scrollY || 0;
      var vh = window.innerHeight || 800;
      for (var i = 0; i < active.length; i++) {
        var it = active[i];
        var prog = (it.top + it.h / 2 - sy - vh / 2) / vh;
        if (prog > 1) prog = 1; else if (prog < -1) prog = -1;
        it.el.style.transform = 'translate3d(0,' + (-prog * MAX).toFixed(2) + 'px,0) scale(1.05)';
      }
      raf = active.length ? requestAnimationFrame(frame) : null;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var it = null;
          for (var i = 0; i < items.length; i++) {
            if (items[i].el === e.target) { it = items[i]; break; }
          }
          if (!it) return;
          var idx = active.indexOf(it);
          if (e.isIntersecting && idx === -1) active.push(it);
          else if (!e.isIntersecting && idx !== -1) {
            active.splice(idx, 1);
            it.el.style.transform = '';
          }
        });
        if (!raf && active.length) raf = requestAnimationFrame(frame);
      },
      { rootMargin: '15% 0px' }
    );

    measure();
    items.forEach(function (it) { io.observe(it.el); });

    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(measure, 180);
    }, { passive: true });
  }

  ready(function () {
    initReveal();
    initHeroDrift();
    initEyebrow();
  });
  onLoad(initParallax);
})();
